function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Html, Image } from "@custom/schema";
import React from "react";
import HubspotForm from "../molecules/HubspotForm";
export default function TwoColIframe(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "md:px-14 pb-10 md:py-16 lg:pb-32 lg:pt-20 overflow-hidden relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto relative z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex lg:gap-x-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/2 mb-8 lg:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-[767px]:bg-gray-30 text-center md:text-left mb-12 md:mb-0 px-6 md:p-0 pt-9 pb-1"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-4xl md:text-5xl xl:text-6xl leading-tight md:leading-tight xl:leading-tight mb-8 font-semibold"
    }, props.heading)), props.image ? /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-0"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: "aspect-video object-cover w-full mb-8",
        source: props.image.source,
        alt: props.image.alt
    })) : null, props.summary && /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-0 block text-lg lg:text-xl prose"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.summary
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/2 px-6 md:px-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "border border-black shadow-md rounded-xl bg-white p-6 md:p-9"
    }, props.formHeading && /*#__PURE__*/ React.createElement("div", {
        className: "text-lg max-[767px]:leading-snug md:text-xl xl:text-2xl text-center mb-6 font-heading max-[767px]:pt-4"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "font-semibold"
    }, props.formHeading), /*#__PURE__*/ React.createElement("p", null, props.formSubheading)), props.form && /*#__PURE__*/ React.createElement(HubspotForm, _object_spread({}, props.form, props)))))), /*#__PURE__*/ React.createElement(BgSvg, null));
}
function BgSvg() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1574px",
        height: "1313px",
        viewBox: "0 0 1574 1313",
        version: "1.1",
        className: "absolute bottom-0 md:bottom-[unset] md:top-0 -right-[720px] md:-right-[900px] lg:-right-[720px] h-80 md:h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Hero Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Download-Page:-No-Selections",
        transform: "translate(-595.000000, -99.000000)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Content",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        transform: "translate(1382.000000, 655.500000) rotate(-270.000000) translate(-1382.000000, -655.500000) translate(726.000000, -131.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M-2.27373675e-13,1361.81977 L266.090716,0 L1312,911.436794 L1296.9061,916.620761 L-2.27373675e-13,1361.81977 L-2.27373675e-13,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        id: "Shape",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        id: "Shape",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        id: "Shape",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        id: "Shape",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        id: "Shape",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    }))))));
}
